"use client";

import { Link } from "@/i18n/routing";
import { Box, Button, Container, Stack, Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import * as Icons from "@mui/icons-material";
import { safeT } from "@/utils/safeT";
import { useTranslations } from "next-intl";
export default function ForbiddenPage() {
  const theme = useTheme();
  const t = useTranslations();
  return (
    <Container
      maxWidth="md"
      disableGutters
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Stack alignItems="center" justifyContent="center" width="100%" spacing={2} px={2}>
        <Icons.ErrorOutlineOutlined
          sx={{
            width: 100,
            height: 100,
            color: "tertiary.dark",
          }}
        />

        <Typography variant="h3" fontWeight="500" sx={{ mt: 2 }}>
          {" "}
          {safeT(t, "ui.message.accessDenied", { defaultMessage: "403 - 접근이 거부되었습니다" })}
        </Typography>
        <Typography
          variant="subtitle1"
          color={theme.palette.text.secondary}
          sx={{ mt: 2, fontStyle: "italic", textWrap: "wrap" }}
        >
          {safeT(t, "ui.message.noPermission", { defaultMessage: "이 페이지에 접근할 권한이 없습니다." })}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mt: 4,
            fontSize: "1rem",
            px: 2,
            py: 0.5,
            borderRadius: 4,
            position: "relative",
            overflow: "hidden",
            "&:hover": {
              "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255, 255, 255, 0.2)",
                animation: "pulse 1.5s infinite",
              },
            },
          }}
          component={Link}
          href="/"
        >
          {safeT(t, "ui.button.safeReturnHome", {
            defaultMessage: "홈으로 안전 귀환",
          })}
        </Button>
      </Stack>
    </Container>
  );
}
